import React, { useState } from "react";
import CardSection from "../../../components/CardSection/card-section";
import { Button, Space } from "antd";
import { RowData } from "../../DataTransfer/data-transfer";
import { SaveDraft } from "../../../services/save-draft";
import { getUserEmail } from "../../../services/utils";
import { useOpenNotification } from "../../../components/Notification/notification";
import TransferContacts from "../Contact/transfer-contacts";

interface EditContactProps {
  handleRequesterDataChange: (data: any) => void;
  handleSupplierDataChange: (data: any) => void;
  handleCloseContact: () => void;
  requesterData: any;
  supplierData: any;
  rowData: RowData;
}

const EditContact: React.FC<EditContactProps> = ({
  handleRequesterDataChange,
  handleSupplierDataChange,
  requesterData,
  supplierData,
  handleCloseContact,
  rowData,
}) => {
  const { openNotification, contextHolder } = useOpenNotification();
  const [loading, setLoading] = useState<boolean>(false);
  const handleSubmit = async () => {
    if(requesterData.length > 0 || supplierData.length > 0) {
    setLoading(true);
    await SaveDraft({
      DTSVersion: rowData.dts_version,
      MSDCompound: rowData.msd,
      record_id: rowData.record_id,
      msd_type: rowData.msd_type,
      supplierCompound: rowData.supplier_compound,
      supplierOrganization: rowData.supplier_org,
      protocol_number: rowData.protocol_number,
      transferId: rowData.transfer_id,
      suppliers: JSON.stringify(supplierData),
      requesters: JSON.stringify(requesterData),
      updated_by: getUserEmail() ?? undefined,
    })
      .then((result: any) => {
        handleCloseContact();
        setLoading(false);
      })
      .catch((error: any) => {
        openNotification("error", "failed to update contact information");
        setLoading(false);
      });
    } else {
      return;
    }
  };

  return (
    <div style={{ margin: "0 5rem" }}>
      <CardSection
        id="contact-section"
        title="Contact"
        inputFields={
          <>
            <TransferContacts
              onDataChange={handleRequesterDataChange}
              contactData={requesterData}
              nextPage="data-transfer"
              errorMessage={
                requesterData.length === 0 ? "This is required field" : null
              }
              contactType="requester"
            />
            <TransferContacts
              onDataChange={handleSupplierDataChange}
              contactData={supplierData}
              nextPage="data-transfer"
              errorMessage={
                supplierData.length === 0 ? "This is required field" : null
              }
              contactType="supplier"
            />
          </>
        }
      />
      <div
        style={{
          backgroundColor: "white",
          margin: "2rem 0",
          padding: "1.5rem",
        }}
      >
        <Space>
          <Button onClick={handleSubmit} loading={loading}>
            Close
          </Button>
        </Space>
      </div>
      {contextHolder}
    </div>
  );
};

export default EditContact;
